import styles from './user-profile.module.scss';
import { UserProfile } from '../../../components/user-profile';
import { useSelector } from 'react-redux';
import { needToUpdateProfile } from 'shared/store/selectors/user.selector';
import { Modal } from 'antd';

const UserProfilePopup = () => {
  const shouldShowPopup = useSelector(({ auth, generalConfig }) =>
    needToUpdateProfile({ auth, generalConfig }),
  );

  return (
    <Modal
      width="100%"
      className={styles.popup}
      open={shouldShowPopup}
      centered
      mask={{ closable: false }}
      closable={false}
      footer={null}
      keyboard={false}>
      <UserProfile isPopup />
    </Modal>
  );
};

export { UserProfilePopup };
